import React from "react";
import { useLocation } from "react-router-dom";
import "./Order_id_holder.css";
import { formatNewDate } from "../../../../../../utils/common";
// import Return_Lottie from "../../../Animation/return_Lottie/Return_Lottie";

function Order_id_holder({ headingText, date, subText }) {
  const location = useLocation();
  const isReturnPage = location.pathname === "/return-order-details";

  return (
    <>
      <section className="Order_id_holder">
        <div className="order_id">
          <div className="img_id_holder">
            {!isReturnPage && (
              <div>
                <div className="img_holder">
                  <img
                    className="Product_img"
                    src={
                      process.env.PUBLIC_URL + "/assets/images/logo/logo.png"
                    }
                    alt="Product_img"
                  />
                </div>
              </div>
            )}

            {isReturnPage && (
              <div className="animation_holder">{/* <Return_Lottie /> */}</div>
            )}

            <div className="ms-3">
              <h2>{headingText}</h2>
              <p
                className={`${subText?.toLowerCase() === "delivered" ? "green" : "red"
                  } sub_text`}
              >
                {subText}
              </p>
            </div>
          </div>
          <p>   {formatNewDate(date, "datetime") || ""}</p>
        </div>
      </section>
    </>
  );
}

export default Order_id_holder;
